export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "iban_extraction_extracting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lecture automatique de l'IBAN en cours..."])},
        "iban_extraction_not_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun IBAN n'a pu être détecté automatiquement. Veuillez le saisir manuellement."])},
        "iban_extraction_failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur a eu lieu lors de l'extraction. Veuillez saisir l'IBAN manuellement."])},
        "iban_extraction_success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'IBAN a été pré-rempli automatiquement. Veuillez vérifier son exactitude."])}
      },
      "en": {
        "iban_extraction_extracting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Automatically reading the IBAN..."])},
        "iban_extraction_not_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No IBAN could be detected automatically. Please enter it manually."])},
        "iban_extraction_failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred during extraction. Please enter the IBAN manually."])},
        "iban_extraction_success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The IBAN was pre-filled automatically. Please check it is correct."])}
      }
    }
  })
}
